export default function HomeSEO() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '耽耽漫画',
    url: 'https://dandanmanhua.com',
    description: '耽耽漫画在线阅读平台，支持下拉式翻页浏览。提供耽耽漫画在线看与耽耽漫画免费阅读服务，海量耽耽漫画全集资源，无需下载即可快速追漫。',
    potentialAction: {
      '@type': 'SearchAction',
      'target': 'https://dandanmanhua.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '耽耽漫画',
    url: 'https://dandanmanhua.com',
    description: '耽耽漫画在线阅读平台，提供耽耽漫画在线看与免费阅读服务',
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://dandanmanhua.com',
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
    </>
  );
}